export function updateRangeValueDisplay() {
    let $range_input = $('input[type=range][data-show-value=true]');

    $range_input.on("input", function(){
       let $input = $(this);
       let $value_display = $input.next('.range-value');
       if ($value_display.length) {
           $value_display.text($input.val());
       }
    });

    $range_input.trigger("input");
}
